module.exports = window["braintree"]["applePay"];